module.exports = function getResource(label, vars = []) {
    let resources = {
        privateProfile: 'Ce profil est privé'
    };
    return resources[label];
};
